<template>
  <div id="chart-line-item-item-box">
    <chart-title leftTitle="MES工序实时监测"></chart-title>
    <el-row class="right_2_card">
      <el-col :span="14"> <div id="right_2" /></el-col>
      <el-col :span="10"
        ><div class="card_right">
          <div class="right_item">
            <div class="item_tag">下料</div>
            <div class="item_number">
              <div class="number_top">
                <span>已完成</span><span>956</span><span>468</span>
              </div>
              <div class="number_bottom">
                <span>待完成</span><span>333</span><span>124</span>
              </div>
            </div>
          </div>
          <div class="right_item">
            <div class="item_tag">封边</div>
            <div class="item_number">
              <div class="number_top">
                <span>已完成</span><span>956</span><span>468</span>
              </div>
              <div class="number_bottom">
                <span>待完成</span><span>333</span><span>124</span>
              </div>
            </div>
          </div>
          <div class="right_item">
            <div class="item_tag">打孔</div>
            <div class="item_number">
              <div class="number_top">
                <span>已完成</span><span>956</span><span>468</span>
              </div>
              <div class="number_bottom">
                <span>待完成</span><span>333</span><span>124</span>
              </div>
            </div>
          </div>
          <div class="right_item">
            <div class="item_tag">造型</div>
            <div class="item_number">
              <div class="number_top">
                <span>已完成</span><span>956</span><span>468</span>
              </div>
              <div class="number_bottom">
                <span>待完成</span><span>333</span><span>124</span>
              </div>
            </div>
          </div>
          <div class="right_item">
            <div class="item_tag" style="line-height: 14px;">铝合金组包</div>
            <div class="item_number">
              <div class="number_top">
                <span>已完成</span><span>956</span><span>468</span>
              </div>
              <div class="number_bottom">
                <span>待完成</span><span>333</span><span>124</span>
              </div>
            </div>
          </div>
          <div class="right_item">
            <div class="item_tag">打包</div>
            <div class="item_number">
              <div class="number_top">
                <span>已完成</span><span>956</span><span>468</span>
              </div>
              <div class="number_bottom">
                <span>待完成</span><span>333</span><span>124</span>
              </div>
            </div>
          </div>
        </div></el-col
      >
    </el-row>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "right_2",
  components: { ChartTitle },
  data() {
    return {
      chart: null,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("right_2"));
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom:"5%",
          textStyle: {
            color: "#C0C4CC",
          },
        },
        radar: {
          // shape: 'circle',
          center: ["43%", "44%"],
          radius: "61%",
          indicator: [
            { name: "下料", max: 6500 },
            { name: "封边", max: 16000 },
            { name: "打孔", max: 30000 },
            { name: "造型", max: 38000 },
            { name: "铝合金组包", max: 52000 },
            { name: "打包", max: 25000 },
          ],
          axisName: {
            fontSize: "14px",
          },
        },
        series: [
          {
            type: "radar",
            data: [
              {
                value: [4200, 3000, 20000, 35000, 50000, 18000],
                name: "新线",
                itemStyle: {
                  color: "#009dff",
                },
              },
              {
                value: [5000, 14000, 28000, 26000, 42000, 21000],
                name: "老线",
                itemStyle: {
                  color: "#40ffe4",
                },
              },
            ],
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 40vh;
  .right_2_card {
    height: calc(100% - 30px);
    .card_right {
      height: 80%;
      .right_item {
        margin-top: 17px;
        display: flex;
        align-items: center;
        .item_tag {
          color: #409eff;
          border: 1px solid #409eff;
          padding: 0px 5px;
          flex-shrink: 0;
          width: 50px;
          text-align: center;
          height: 30px;
          line-height: 30px;
        }
        .item_number {
          width: 120px;
          margin-left: 10px;
          .number_top {
            color: #9bfb84;
            display: flex;
            justify-content: space-between;
          }
          .number_bottom {
            color: #fffb95;
            display: flex;
            justify-content: space-between;
          }
        }
      }
    }
  }
  #right_2 {
    height: 100%;
  }
}
</style>
